import { render, staticRenderFns } from "./close-issue.vue?vue&type=template&id=e199255a"
import script from "./close-issue.vue?vue&type=script&lang=js"
export * from "./close-issue.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports